import { Copy, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useApp } from "@/contexts/AppContext";

const ShareModal = ({ group, onClose }) => {
  const { t } = useApp();
  const [copied, setCopied] = useState(false);
  const shareUrl = `${window.location.origin}/group/${group.id}`;

  const copyLink = () => {
    navigator.clipboard.writeText(shareUrl).then(() => {
      setCopied(true);
      toast.success(t('link_copied'));
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-sm" data-testid="share-modal">
        <DialogHeader>
          <DialogTitle className="font-outfit text-xl">{t('share_group')}</DialogTitle>
        </DialogHeader>

        <p className="text-sm text-zinc-500">{t('share_desc')}</p>

        <div className="flex gap-2">
          <Input
            data-testid="group-share-link-input"
            value={shareUrl}
            readOnly
            className="h-11 font-mono text-xs bg-zinc-50 text-zinc-600"
          />
          <Button
            data-testid="copy-link-btn"
            onClick={copyLink}
            className={`h-11 shrink-0 transition-all ${copied ? 'bg-emerald-600 hover:bg-emerald-700' : 'bg-zinc-900 hover:bg-zinc-800'} text-white`}
          >
            {copied ? <Check size={15} /> : <Copy size={15} />}
          </Button>
        </div>

        <p className="text-xs text-zinc-400">{t('share_note')}</p>
      </DialogContent>
    </Dialog>
  );
};

export default ShareModal;
